import { ICompany } from "../core/models/company.model";
import { ITopCompanies } from "../core/models/results.model";
import { ICatalogueThemes } from "../core/models/thematic.model";

// app.state.ts
export interface Tab {
  tabId: string;
  search_type: string;
  params: Iparams|null;
  tab_name:string;
  sidenav_results: {
    [key: string]: any;
  };
  isLoading?: boolean; // Add tab-specific loading state
  universe?:IUniverseSelection;
}

export interface Iparams{
  entityids:string[] |null|undefined,
  query:string|null|undefined,
  gsubind:string[]|null;
  entity_data:ICompany|null|undefined;
  query_data:ICatalogueThemes|null|undefined;
}

export interface MainState {
  activeTabId: string;
  activeSideTab: string;
  activeTab: Tab | null;
  // availableSidenavOptions: string[];
}

export interface AppState {
  main: MainState;
  TabList: Tab[];
}

// Always start with empty tabs - load from DB on app init
export const initialTabListState: Tab[] = [];

// Always start with empty main state - load from DB on app init
export const initialMainState: MainState = {
  activeTabId: '',
  activeSideTab: '',
  activeTab: null,
};
export const initialUniverseState: IUniverseSelection = {
    include_public:true,
    include_private:false,
}

export const initialState: AppState = {
  main: initialMainState,
  TabList: initialTabListState,
};


export interface IUniverseSelection{
  include_private:boolean,
  include_public:boolean,
  min_mcap?:number;
  max_mcap?:number;
}

export interface StoredTabData {
  tabId: string;
  search_type: string;
  params: Iparams | null;
  tab_name: string;
  universe?: IUniverseSelection;
}

export const companySideNavList:string[]=['executive_summary','innovation_activity','tech_footprint','innovation_quality','competitive_benchmarking_peergroup','clustering_innovation_activity','clustering_tech_footprint','clustering_peer_group','cluster_treemap', 'inventions_view','company_private_competitors','company_public_competitors']
export const themeSideNavList:string[]=['innovation_activity','thematic_public_competitors','thematic_private_competitors','thematic_custom_peer_group','tech_footprint','cluster_treemap','inventions_view']
